import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  Button,
  CircularProgress,
} from '@mui/material';
import { PrecisionManufacturing, PlayArrow, Stop } from '@mui/icons-material';
import { BRAND } from '../../config/brand';
import {
  useGetMachineFloorQuery,
  useReleaseMachineMutation,
} from '../../api/machineApi';

export const MachineFloor: React.FC = () => {
  const { data: machines, isLoading, refetch } = useGetMachineFloorQuery();
  const [releaseMachine] = useReleaseMachineMutation();

  const statusColor = (status: string) => {
    if (status === 'active') return 'success';
    if (status === 'maintenance') return 'warning';
    return 'default';
  };

  if (isLoading) return <CircularProgress sx={{ color: BRAND.colors.navy }} />;

  return (
    <Box>
      <Typography variant="h4" sx={{ color: BRAND.colors.navy, fontWeight: 700, mb: 3 }}>
        Machine Floor
      </Typography>

      <Grid container spacing={2}>
        {(machines as any[])?.map((machine) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={machine.id}>
            <Card
              sx={{
                borderTop: `4px solid ${machine.currentJob ? '#2e7d32' : BRAND.colors.navy}`,
                height: '100%',
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <PrecisionManufacturing sx={{ color: BRAND.colors.navy }} />
                  <Typography variant="subtitle1" fontWeight={700}>{machine.name}</Typography>
                </Box>
                <Chip size="small" label={machine.type} sx={{ mr: 0.5 }} />
                <Chip size="small" label={machine.status} color={statusColor(machine.status) as any} />
                <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                  Line: {machine.productionLine?.name || 'Unassigned'}
                </Typography>
                {machine.currentJob ? (
                  <Box sx={{ mt: 1, p: 1, bgcolor: 'success.light', borderRadius: 1 }}>
                    <Typography variant="caption" fontWeight={600}>
                      <PlayArrow fontSize="inherit" /> Running: {machine.currentJob.jobType}
                    </Typography>
                  </Box>
                ) : (
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                    Idle — {machine.utilization ?? 0}% utilization
                  </Typography>
                )}
                {machine.currentJob && (
                  <Button
                    size="small"
                    startIcon={<Stop />}
                    onClick={async () => { await releaseMachine(machine.id); refetch(); }}
                    sx={{ mt: 1 }}
                  >
                    Release
                  </Button>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MachineFloor;
